function Success(config) {
  let calculator = new Calculator2021(CalculatorConfiguration, fundShares)

  this.init = function (urlParams) {
    let incomeTaxBenefitPerMonth = Math.round(CalculatorConfiguration.maximumIncomeTaxBenefit / 12)

    return {
      signedDocumentId: urlParams.signedDocumentId,
      cancellation: urlParams.cancellation === 'true',
      suspend: urlParams.suspend === 'true',
      exit: urlParams.exit === 'true',
      suspendCancellationMaxDate: this._getSuspendCancellationMaxDate(new Date()),
      exitCancellationMaxDate: this._getExitCancellationMaxDate(new Date()),
      thirdPillarOffer: !(urlParams.exit === 'true' || urlParams.suspend === 'true'),
      sliderMinimum: 0,
      sliderValue: Math.min(session.pension.thirdPillar.lastPayment.total, incomeTaxBenefitPerMonth),
      sliderMaximum: incomeTaxBenefitPerMonth,
      estimation: calculator.calculate(session.pension, session.pension.thirdPillar.averageMonthlyContribution).total.toFixed(2),
      banklinkPaymentUrl: config.banklinkPaymentUrl,
      hasThirdPillarAssets: session.pension.thirdPillar?.assets?.length > 0
    }
  }

  this._getSuspendCancellationMaxDate = function(today) {
    switch (today.getMonth() + 1) {
      case 12:
        return '31.03.' + (today.getFullYear() + 1)
      case 1:
      case 2:
      case 3:
        return '31.03.' + today.getFullYear()
      case 4:
      case 5:
      case 6:
      case 7:
        return '31.07.' + today.getFullYear()
      default:
        return '30.11.' + today.getFullYear()
    }
  }

  this._getExitCancellationMaxDate = function(today) {
    switch (today.getMonth() + 1) {
      case 12:
        return '31.07.' + (today.getFullYear() + 1)
      case 1:
      case 2:
      case 3:
        return '31.07.' + today.getFullYear()
      case 4:
      case 5:
      case 6:
      case 7:
        return '30.11.' + today.getFullYear()
      default:
        return '31.03.' + (1 + today.getFullYear())
    }
  }

  this.done = function (urlParams, params) {
    let thirdPillarOffer = new ThirdPillarOffer()
    thirdPillarOffer.init()

    $.post('/load-pension')
      .done(function (result) {
        session.setPension(new Pension(result.pension))
        session.setCustomer(result.customer)
      })
  }
}